<template>
  <header>
    <div class="container">
      <Logo />
      <nav>
        <ul class="site-functions">
          <li class="new" v-if="!isHomepage">
            <router-link to="/">
              <!-- <IconNew /> -->
              <span>New</span>
            </router-link>
          </li>
        </ul>
        <!-- <ul class="account">
          <li class="signup">
            <router-link to="/signup">
              <span>Sign Up</span>
            </router-link>
          </li>
          <li class="signin">
            <router-link to="/signin">
              <span>Sign In</span>
            </router-link>
          </li>
        </ul> -->
      </nav>
    </div>
  </header>
</template>

<script>
import Logo from '@/components/icons/Logo.vue'

export default {
  name: 'Header',
  components: {
    Logo
  },
  computed: {
    isHomepage () {
      return this.$route.path === '/'
    }
  }
}
</script>

<style>

header {
  background: #fff;
  box-shadow: 0 0 2px rgba(0,0,0,0.2);
}

header .container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 16px;
}

header nav {
  margin-top: 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

header ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
}

header li {
  font-size: 16px;
  line-height: 24px;
  display: block;
  margin-right: 24px;
}

header li:last-child {
  margin-right: 0;
}

header li.signup {
  font-weight: bold;
}

header ul li a {
  display: flex;
  color: #001DDD;
}

header ul li a:hover {
  text-decoration: none;
}

header svg .icon-glyph {
  stroke: #001DDD;
  fill: none;
}

header svg .icon-shape {
  stroke: currentColor;
  fill: none;
}

header ul li a.router-link-exact-active {
  color: #001DDD;
}

header ul li a.router-link-exact-active svg .icon-glyph {
  stroke: #1D1E1F;
}

header ul li a.router-link-exact-active svg .icon-shape {
  fill: #00EF71;
}

header svg {
  margin-right: 8px;
  display: block;
}

header span {
  display: block;
}

@media screen and (min-width: 640px) {
  header .container {
    flex-direction: row;
    padding: 16px 24px;
    justify-content: space-between;
  }

  header nav {
    margin: 0;
    flex-grow: 1;
    margin-left: 32px;
  }

  header ul.account {
    flex-direction: row-reverse;
  }

  header ul.site-functions li {
    margin-right: 24px;
    margin-left: 0;
  }

  header li {
    font-size: 16px;
    line-height: 24px;
    margin-right: 0;
    margin-left: 24px;
  }

  header li:last-child {
    margin-left: 0;
  }
}

</style>
